<template lang="pug">
  .wrapper(ref="container")
    .omitir-valores
      p-checkbox(label="exibir valores zerados", v-model="showZeroValues")

    .container(v-if="sumTimes && somas && !loadingSumTimes")
      .flexy-container(key="realsums" v-if="somas.length")
        .flexy-item(v-for="sum in somas")
          .line.anim-slide-up(:title="sum.hover" style="text-align: center")
            .box-title.lowercase {{ sum.text }}
            .box(:class="parseColor(sum.field)") {{ sum.value }}

        .flexy-item(v-for='sum in somas', v-if="hasArbitrary(somas, sum)")
          .line(:title="sum.hover" style="text-align: center")
            .box-title {{ sum.text }}
            .box.success
              | {{ hasArbitrary(somas, sum) }}

      h3.no-apont-warning.anim-slide-up(v-if="somas && !somas.length") nenhum apontamento

    .container(v-if="loadingSumTimes")
      .flexy-container(key="loadingSums")
        .flexy-item(v-for='i in 10', :key="i")
          .line(style="text-align: center")
            svg(viewBox="0 0 100 50" preserveAspectRatio="xMidYMid meet")
              rect(x="20" y="3" width="60" height="10" style="fill: #e0e0e0;")
              rect(x="0" y="16" width="100" height="20" style="fill: #e0e0e0;")

    .legenda
      .box.default horas extras comuns
      .box.warning  horas extras extraordinárias
      .box.info  horas extras especiais

</template>

<script>
import Accordion from 'src/common/VueAccordion'
import { mapState } from 'vuex'
import { parseColorApontamento } from 'src/utils'

export default {
  created () {
    try {
      this.dataShowZeroValues = JSON.parse(localStorage.getItem('showZeroValuesApontamentos')) === true
    } catch (e) {}
  },
  data () {
    return {
      dataShowZeroValues: false
    }
  },
  computed: {
    ...mapState('timesheet', ['sumTimes', 'loadingSumTimes']),
    showZeroValues: {
      get () {
        return this.dataShowZeroValues
      },
      set (val) {
        localStorage.setItem('showZeroValuesApontamentos', JSON.stringify(val))
        this.dataShowZeroValues = val
      }
    },
    somas () {
      const sums = this.sumTimes[this.sumTimes.length - 1]

      if (!sums) return null

      return sums.title_list
        .map(line => {
          return {value: sums[line], text: sums.titles[line].text, hover: sums.titles[line].hover, field: line}
        })
        .filter(line => {
          return (line.value !== '00:00' && line.value !== 0) || this.showZeroValues
        })
    }
  },
  methods: {
    hasArbitrary (sumValues, tmNameKey) {
      if (!sumValues.arbs) {
        return false
      }
      try {
        const value = sumValues.arbs[tmNameKey]['arb']
        if (![0, 0.0, '00:00', '00:0', '0:00', '0:0', '00:00H', '00.00H', '0.00H', '0.0H', '0.0'].includes(value.toUpperCase())) {
          return value
        }
      } catch (e) {
        console.warn(e)
        return false
      }
      return false
    },
    focus () {
      this.$refs.button.focus()
      // if (!this.open) {
      //   this.openSumTimes()
      // }
      setTimeout(() => {
        this.$refs.container.scrollIntoView()
      }, 100)
    },
    focusOut (e) {
      if (e.key === 'ArrowUp') {
        this.$emit('focusOut')
      }
    },
    parseColor (apont) { return parseColorApontamento(apont) }
  },
  components: { Accordion }
}
</script>

<style scoped lang="scss">
.wrapper {
  text-align: center;
  display: grid;
  grid-template-columns: 1fr 3fr 1fr;
  grid-template-rows: min-content min-content min-content;

  .omitir-valores {
    grid-column: 3;
    grid-row: 1;
    display: flex;
    justify-content: flex-end;
    padding-right: 47px;
  }

  .container {
    grid-column: 1/4;
    grid-row: 2;
  }

  .flexy-container {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    justify-content: flex-start;
    align-items: flex-end;
    grid-column-gap: 50px;
    grid-row-gap: 10px;

    .flexy-item {
      width: 100%;

      .line {
        display: flex;
        flex-direction: column;
        align-items: center;
        div { width: 100%; }

        .box {
          font-size: 13px !important;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          padding: 3px 5px;
          display: flex;
          justify-content: center;
          flex-direction: column;
          text-align: center;
        }
        .box-title {
          font-size: 15px;
        }
      }
    }
  }

  .no-apont-warning {
    grid-column: 2;
    grid-row: 2;
  }

  .legenda {
    display: flex;
    grid-column: 1/4;
    grid-row: 3;
    justify-content: space-between;
    margin: 40px 0;

    .box {
      width: 30%;
    }
  }
}

.default {
  border: 2px solid var(--color-default);
}
.warning {
  border: 2px solid var(--color-warning);
}
.info {
  border: 2px solid var(--color-info);
}
.success {
  border: 2px solid var(--color-success);
}
</style>
